import axios from "axios";
// const server = "https://scriptio.mangotech-api.com/api/v1";
// export const baseUrl = "https://scriptio.mangotech-api.com";

const server = "https://api.e-rx.info/api/v1";
// const server = "https://api.e-rx.info/api/v1";
export const baseUrl = "https://api.e-rx.info";
// export const baseUrl = "https://api.e-rx.info";

const instance = axios.create({
  baseURL: server,
});

instance.interceptors.request.use((request) => {
  let token = localStorage.getItem("token");
  request.headers = {
    Accept: "application/json, text/plain, */*",
    Authorization: `Bearer ${token}`,
  };
  return request;
});

instance.interceptors.response.use(
  (response) => {
    if (response) {
      return response;
    }
  },
  function (error) {
    // *For unAuthorized
    // if (error.response.status === 401) {
    //   localStorage.clear()
    // }
    return Promise.reject(error);
  }
);

export default instance;
